import Result from "@/core/common/Result";
import { IPlainBase64 } from "../ports/PlainBase64";
import { injectable } from "inversify";
import "reflect-metadata";

@injectable()
export class PlainBase64Adapter implements IPlainBase64 {
  handlePlainBase64(file: string): Result<string> {
    const plain = file.split(",").at(1);

    if (plain === undefined)
      Result.fail("Não foi possível converter o arquivo");

    return Result.ok(plain);
  }
}
